import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import useAutoSelectValue from './util/use-auto-select-value';

const options = [
  { id: '0', label: 'Budget', value: 0 },
  { id: '1', label: 'Min', value: 1 },
];

export function CompareByFilter({
  autoSelectIfEmpty = false,
  useContextFn,
  errorMessages = {},
}: {
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    compareBy: number;
    onChangeCompareBy: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const { compareBy: value, onChangeCompareBy: onChange } = useContextFn();
  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess: true,
  });
  const handleChange = useTransformSelectValue(onChange);

  const helperText = errorMessages['compareBy'];
  return (
    <Select
      fullWidth
      size="small"
      value={value}
      label="Compare Available By"
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
